<script lang="ts">
  import { onMount } from "svelte";

  const DELAY_START = 500; // milliseconds
  const DELAY_BETWEEN_DAYS = 200; // milliseconds

  export let checkedDays: Map<string, boolean>;
  export let animate = true;
  let isMounted = false;

  const daysArray = Array.from(checkedDays.keys());
  let selectedDays = Array(daysArray.length).fill(false);

  const startAnimation = () => {
    let delayMultiplier = 0; // Start with a delay of 500ms for the first day

    daysArray.forEach((dayName, index) => {
      if (checkedDays.get(dayName)) {
        setTimeout(
          () => {
            selectedDays[index] = true;
            selectedDays = selectedDays; // Trigger Svelte reactivity
          },
          // add initial delay
          DELAY_START + delayMultiplier * DELAY_BETWEEN_DAYS
        );

        delayMultiplier++; // Only increment delay for days that are actually selected
      }
    });
  };

  $: if (animate && isMounted) {
    startAnimation();
  }

  onMount(() => {
    isMounted = true;
  });
</script>

<div class="week-container">
  {#each daysArray as day, index}
    <div class="day-circle" class:selected={selectedDays[index]}>{day.slice(0, 1).toLocaleUpperCase()}</div>
  {/each}
</div>

<style>
  :global(.badges > span) {
    font-size: 1em;
    margin-left: 6px;
    height: 2em;
    width: 2em;
  }

  .week-container {
    display: flex;
    gap: 16px;
    /* padding: 20px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.05); */
  }

  /* Day Circle Styles */
  .day-circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #1a1d24;
    border: 2px solid #2a2f3b;
    color: #64748b;
    font-size: 1.1rem;
    font-weight: 600;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    position: relative;
    transition:
      color 0.3s ease,
      border-color 0.3s ease,
      background-color 0.3s ease;

    /* Unselect/Pop-out animation by default when class is removed */
    animation: unselectPop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  }

  /* Selected State */
  .day-circle.selected {
    color: #ffffff;
    background-color: #059669;
    border-color: #34d399;
    box-shadow:
      0 0 10px rgba(52, 211, 153, 0.4),
      0 0 25px rgba(52, 211, 153, 0.2);
    /* Satisfying elastic pop-in animation */
    animation: selectPop 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.5) both;
  }

  /* Ripple Effect Element */
  .day-circle::after {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    border-radius: 50%;
    border: 2px solid #34d399;
    opacity: 0;
    transform: scale(1);
    pointer-events: none;
  }

  .day-circle.selected::after {
    animation: ripple 0.5s ease-out both;
  }

  /* Scale up bouncy animation on select */
  @keyframes selectPop {
    0% {
      transform: scale(1);
    }
    30% {
      transform: scale(0.85);
    }
    70% {
      transform: scale(1.15);
    }
    100% {
      transform: scale(1);
    }
  }

  /* Quick slight dip and settle on unselect */
  @keyframes unselectPop {
    0% {
      transform: scale(1);
    }
    40% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }

  /* Bursting glow ring when activated */
  @keyframes ripple {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    70% {
      opacity: 0.5;
    }
    100% {
      opacity: 0;
      transform: scale(1.4);
    }
  }
</style>
